import { render, staticRenderFns } from "./AgentStatistics.vue?vue&type=template&id=061ac408&"
import script from "./AgentStatistics.vue?vue&type=script&lang=ts&"
export * from "./AgentStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgentStatistics.vue"
export default component.exports